import {useState} from "react";
import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {Col} from "@pg-design/grid";
import {flex, onDesktop, p, ph, textAlign} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

import {flexGap} from "../../../components/css_helpers/flex";
import {AllCitiesPricingBox} from "./AllCitiesPricingBox";
import {SelectedCityPricingBox} from "./SelectedCityPricingBox";
import {SubscriptionBox} from "./SubscriptionBox";
import {SubscriptionPeriodRadio} from "./SubscriptionPeriodRadio";

export type SUBSCRIPTION_PERIODS = "annually" | "monthly";

export const BdSubscriptionBox = () => {
    const {t} = useTranslation();
    const [selectedPeriod, setSelectedPeriod] = useState<SUBSCRIPTION_PERIODS>("annually");

    return (
        <SubscriptionBox>
            <Col md={12}>
                <Text variant="headline_3" as="p" align="center">
                    {t("pricing.bd_subscription.title")}
                </Text>
                <Text variant="body_copy_1" css={headerText}>
                    {t("pricing.bd_subscription.description_1")}
                    <br />
                    {t("pricing.bd_subscription.description_2")}
                </Text>
                <div css={configWrapper}>
                    <SubscriptionPeriodRadio selectedPeriod={selectedPeriod} onChange={setSelectedPeriod} />
                </div>
            </Col>

            <Col sm={4} md={6}>
                <AllCitiesPricingBox paymentPeriod={selectedPeriod} />
            </Col>

            <Col sm={4} md={6}>
                <SelectedCityPricingBox paymentPeriod={selectedPeriod} />
            </Col>
        </SubscriptionBox>
    );
};

const configWrapper = css`
    ${flex("flex-end", "space-between")};
    ${flexGap(2)};
    flex-wrap: wrap;
`;

const headerText = css`
    ${textAlign("center")};
    ${p(3)};
    ${onDesktop(css`
        ${ph(20)};
    `)}
`;
